import * as Yup from 'yup';

import { ProfileFieldsetSchema } from 'components/form/ProfileFieldset';

import { ProfileFormValuesType } from './ProfileForm.types';

export const ProfileFormSchema = Yup.object<ProfileFormValuesType>().concat(
  ProfileFieldsetSchema
);
